// extracted by mini-css-extract-plugin
export var boxItems = "_7a-1";
export var boxItemsLg = "_7a-2";
export var button = "_7a-7";
export var buttonLg = "_7a-8";
export var filterGroupBox = "_7a-0";
export var icon = "_7a-3";
export var iconSecondary = "_7a-6";
export var iconWrapper = "_7a-4";
export var iconWrapperLg = "_7a-5";